import React from 'react'
import { useState,useEffect } from 'react';
import ApiUrl from '../../../../configTools/apiUrl';

const Profile = ({username}) => {
    const [userDetails,setUserDetails] = useState({
      id : 0,
      activetoday : true,
      username : "",
      discription : "",
      firstname : "",
      lastname : "",
      followers : 0,
      following : 0,
      averagestars : 3,
      reviewcount : 100,
      image : "",
      followingthis : false,
      soldcount : 0,
      postcount : 0,
      contact : ""
    });
    useEffect(()=>{
        fetch(ApiUrl.API_URL_Profile+"/"+0+"/"+username)
        .then(res=>res.json())
        .then(data =>{
        if(data.success){
            setUserDetails(data.responce);
        }
        });
    },[username])
  return (
    <div className='top_profile_container'>
        <div className='top_profile_row'>
            <div className='top_profile_image'>
                <label style={{cursor:"pointer"}}>
                    <div style={{
                        width: "100%",
                        paddingTop: "80%",
                        borderRadius: "10px",
                        position: "relative",
                        backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+userDetails.image})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        marginBottom:"20px"
                        
                    }}>
                    </div>
                </label>
            </div>
            <div style={{width:"10%"}}></div>
            <div className='top_profile_details'>
                <div className='top_profile_details_top_container'>
                    <h3>{userDetails.firstname} {userDetails.lastname}</h3>
                </div>
                <div className='top_profile_details_middle_container'>
                    <p><b>{userDetails.postcount}</b>Posts</p>
                    <p><b>{userDetails.followers}</b>Followers</p>
                    <p><b>{userDetails.following}</b>Following</p>
                </div>
                <div className='top_profile_details_bottom_container'>
                    <h5>{userDetails.username}</h5>
                    <p>{userDetails.discription}</p>
                    <h5>{userDetails.contact}</h5>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Profile
